module.exports = __webpack_public_path__ + "img/temp-bg-competition.a586e10d.svg";